// Localização: frontend/src/components/Financeiro/FormContaBancaria.jsx

import React, { useState } from 'react';
import PrimaryButton from '../Common/PrimaryButton';

const FormContaBancaria = ({ initialData, onSubmit, onClose, isEditing }) => {
    const [formData, setFormData] = useState({
        nome: '',
        banco: '',
        agencia: '',
        conta: '',
        tipo_conta: 'Corrente',
        saldo_inicial: 0.00,
        observacoes: '',
        ativo: true,
        ...initialData
    });
    const [error, setError] = useState(null);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : (name === 'saldo_inicial' ? parseFloat(value) || 0 : value)
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setError(null);

        // Validações
        if (!formData.nome || !formData.banco || !formData.conta || !formData.tipo_conta) {
            setError('Nome, banco, conta e tipo de conta são obrigatórios.');
            return;
        }

        if (formData.saldo_inicial < 0) {
            setError('Saldo inicial não pode ser negativo.');
            return;
        }

        onSubmit(formData);
    };

    return (
        <form onSubmit={handleSubmit} className="space-y-4">
            {error && (
                <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded">
                    {error}
                </div>
            )}

            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                    Nome da Conta <span className="text-red-500">*</span>
                </label>
                <input
                    type="text"
                    name="nome"
                    value={formData.nome}
                    onChange={handleChange}
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-emerald-500 focus:ring-emerald-500"
                    required
                    placeholder="Ex: Conta Principal"
                />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Banco <span className="text-red-500">*</span>
                    </label>
                    <input
                        type="text"
                        name="banco"
                        value={formData.banco}
                        onChange={handleChange}
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-emerald-500 focus:ring-emerald-500"
                        required
                        placeholder="Ex: Banco do Brasil"
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Agência
                    </label>
                    <input
                        type="text"
                        name="agencia"
                        value={formData.agencia || ''}
                        onChange={handleChange}
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-emerald-500 focus:ring-emerald-500"
                        placeholder="Ex: 1234"
                    />
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Número da Conta <span className="text-red-500">*</span>
                    </label>
                    <input
                        type="text"
                        name="conta"
                        value={formData.conta}
                        onChange={handleChange}
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-emerald-500 focus:ring-emerald-500"
                        required
                        placeholder="Ex: 12345-6"
                    />
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        Tipo de Conta <span className="text-red-500">*</span>
                    </label>
                    <select
                        name="tipo_conta"
                        value={formData.tipo_conta}
                        onChange={handleChange}
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-emerald-500 focus:ring-emerald-500"
                        required
                    >
                        <option value="Corrente">Corrente</option>
                        <option value="Poupança">Poupança</option>
                        <option value="Investimento">Investimento</option>
                    </select>
                </div>
            </div>

            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                    Saldo Inicial (R$)
                </label>
                <input
                    type="number"
                    name="saldo_inicial"
                    value={formData.saldo_inicial}
                    onChange={handleChange}
                    step="0.01"
                    min="0"
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-emerald-500 focus:ring-emerald-500"
                    placeholder="0.00"
                />
            </div>

            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                    Observações
                </label>
                <textarea
                    name="observacoes"
                    value={formData.observacoes || ''}
                    onChange={handleChange}
                    rows="3"
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-emerald-500 focus:ring-emerald-500"
                    placeholder="Observações adicionais sobre a conta..."
                />
            </div>

            {isEditing && (
                <div className="flex items-center">
                    <input
                        type="checkbox"
                        name="ativo"
                        checked={formData.ativo}
                        onChange={handleChange}
                        className="h-4 w-4 text-emerald-600 focus:ring-emerald-500 border-gray-300 rounded"
                    />
                    <label className="ml-2 block text-sm text-gray-700">
                        Conta ativa
                    </label>
                </div>
            )}

            <div className="flex justify-end space-x-2 mt-6 pt-4 border-t border-gray-200">
                <PrimaryButton
                    type="button"
                    onClick={onClose}
                    className="bg-gray-500 hover:bg-gray-700"
                >
                    Cancelar
                </PrimaryButton>
                <PrimaryButton type="submit">
                    {isEditing ? 'Salvar Alterações' : 'Cadastrar'}
                </PrimaryButton>
            </div>
        </form>
    );
};

export default FormContaBancaria;

